import { Heading, HStack, Icon, IconButton, Progress, Stack } from '@chakra-ui/react'
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

export const TopControlTest = (props: CardCarouselControlProps) => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <Stack
      align={getBreakpointValue(['center', 'center'])}
      direction={'row'}
      justify={'space-between'}
      marginBottom={4}
      minHeight={'48px'}
      width={'full'}
    >
      {props.title && (
        <>
          {typeof props.title === 'string' ? (
            <Heading size={getBreakpointValue(['md'])} textStyle={'uppercase'}>
              {props.title}
            </Heading>
          ) : (
            props.title
          )}
        </>
      )}
      {props.pages.length > 1 ? (
        <HStack align={'center'} gap={2} justify={'center'}>
          <IconButton
            aria-label={'Previous Item'}
            disabled={props.activeItemIndex === 0}
            size={'md'}
            title={'Previous Item'}
            variant={'ghost'}
            onClick={() => props.prevItem()}
          >
            <Icon asChild>
              <FiChevronLeft />
            </Icon>
          </IconButton>
          <Progress.Root
            colorPalette={'purple'}
            flexGrow={1}
            hidden={getBreakpointValue([true, true, false])}
            size={'xs'}
            value={props.pagesPercent === 100 ? 100 : Math.max(10, props.itemsPercent)}
            variant={'subtle'}
            width={'10em'}
          >
            <Progress.Track>
              <Progress.Range />
            </Progress.Track>
          </Progress.Root>
          <IconButton
            aria-label={'Next Item'}
            disabled={props.activeItemIndex === props.items.length - 1}
            size={'md'}
            title={'Next Item'}
            variant={'ghost'}
            onClick={() => props.nextItem()}
          >
            <Icon asChild>
              <FiChevronRight />
            </Icon>
          </IconButton>
        </HStack>
      ) : (
        <div />
      )}
    </Stack>
  )
}
